module.exports = __webpack_public_path__ + "static/media/gravitus-app_2screen.e5142e8d.png";